<template>
  <div class="flex justify-end items-center">
    <SwdDropDown :options="getActionsOptions" @select="handleSelect">
      <template #titleDropDown>
        <div class="flex items-center cursor-pointer">
          <span class="px-2 py-2 text-xs uppercase font-semibold text-primary">
            {{ getNameTitle }}
          </span>
          <InlineSvg :src="IconUserAction" />
        </div>
      </template>
    </SwdDropDown>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'

import { useSecureLogout } from '@/api/secure-upload/use-secure-logout'
import IconUserAction from '@/assets/svg/icon-user-action.svg'

export default {
  name: 'UserSecureAction',
  setup() {
    const store = useStore()
    const { logout } = useSecureLogout()

    // Dropdown actions
    const getActionsOptions = computed(() => [{ title: 'Logout', command: 'logout', class: 'font-medium' }])

    // Name from globalComponents store
    const getNameTitle = computed(() => {
      const member = store.state.globalComponents.secureMemberData
      if (!member?.member?.name) {
        return 'User'
      }
      return member.member.name
    })

    // Improved logout: clear session and validate token expiration
    let hasLoggedOut = false
    const handleLogout = async () => {
      if (hasLoggedOut) {
        return
      }
      hasLoggedOut = true
      await logout()
      setTimeout(() => {
        hasLoggedOut = false
      }, 2000)
    }

    // Short event listener for session expired
    onMounted(() => {
      window?.addEventListener('secure-upload-session-expired', handleLogout)
    })
    onUnmounted(() => {
      window?.removeEventListener('secure-upload-session-expired', handleLogout)
    })

    const actionsMap = {
      logout: handleLogout,
    }

    const handleSelect = (command) => {
      const actionHandler = actionsMap[command]
      if (actionHandler) {
        actionHandler()
      }
    }

    return {
      IconUserAction,
      getNameTitle,
      getActionsOptions,
      handleSelect,
      handleLogout,
    }
  },
}
</script>
